<template>
    <div class="bg-white px-3 index" >
        <div class="add_tits" ref="title">
            <el-form class="form-inlines u-f u-ac u-jsb " :inline="true">
                <div>
                    <!-- <el-form-item label="模糊搜索">
                        <el-input v-model="titles" placeholder="请输入内容" clearable size="small"></el-input>
                    </el-form-item> -->
                    <el-form-item label="类型">
                        <el-select v-model="category_id" size="small" placeholder="请选择" >
                            <el-option v-for="item  in type_options" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                    </el-form-item>
                </div>
                <div>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="add">新增
                        </el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="heights" ref="configurationTable">
                <el-table-column prop="name" label="类别" show-overflow-tooltip>
                </el-table-column>
                <el-table-column label="中药" width="150">
                    <template slot-scope="scope">
                        <el-button size="mini" type="text" @click="handlelookqu(scope.$index, scope.row)">查看
                        </el-button>

                    </template>
                </el-table-column>
                <el-table-column prop="create_time" label="创建时间" show-overflow-tooltip width="180"> </el-table-column>
                <el-table-column label="操作" width="260">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑
                        </el-button>
                        <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>

        </div>
        <!--  -->
        <el-dialog title="分类设置" :visible.sync="dialogs" top="180px" width="35%" center class="dialogs"
            :close-on-click-modal='false'>
            <el-divider></el-divider>
            <div class="dialog-ibox-content" v-loading='editloading'>
                <el-form ref="form" :model="form" label-width="140px" :rules="rule" class="demo-ruleForm">
                    <el-row>
                        <el-form-item label="类型">
                            <el-select v-model="form.category_id" size="small" placeholder="请选择" >
                                <el-option v-for="item  in type_options" :key="item.id" :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="类型名称" prop="name">
                            <el-input placeholder="请输入内容" size='small' style="max-width:300px" v-model="form.name"> </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" :loading='subloading' @click="submit('form')" size="small">确 定
                            </el-button>
                            <el-button @click="dialogs = false" size="small">取 消</el-button>
                        </el-form-item>
                    </el-row>
                </el-form>
            </div>
        </el-dialog>
        <!-- 中药列表-->
        <el-dialog title="中药列表" :visible.sync="contentvotedetail" top="50px" width="60%" class="dialogs"  :close-on-click-modal='false'>
            <el-divider></el-divider>
            <Contentvotelist ref="votelist" />
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="contentvotedetail=false" size="small">确定</el-button>
            </span>
        </el-dialog>

        <!-- 预览图片 -->
        <el-dialog :visible.sync="previewModel" width="60vw" top="5vh">
            <div style="margin: -60px -20px -30px -20px;">
                <img :src="previewUrl" class="w-100" />
            </div>
        </el-dialog>
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    import Contentvotelist from "./yao.vue";
    export default {
        components: {
            Contentvotelist
        },
        data() {
            return {
                dialog: false,
                titles: '',
                loading: false,
                tableData: [],
                currentPage: 1,
                pagesize: 15,
                count: 0,
                heights: null,
                mtheights: {
                    height: null,
                    "overflow": "auto",
                },

                // 
                NumList: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L'],
                eid: '',
                props: {
                    label: 'problem',
                    children: 'children'
                },
                wt_options: [],
                dialogs: false,
                form: {
                    name: '',
                    category_id: 2,
                    wjxx: [],
                    detail: '',
                    content: '',
                    fileList: [],
                    answers: [{
                        name: "",
                        pstart: '',
                        pend: ''
                    }],
                    type: 1
                },
                rule: {
                    name: [{
                        required: true,
                        message: '名称不能为空'
                    }],
                    content: [{
                        required: true,
                        message: '请输入描述'
                    }],

                },
                fileListed: [],
                previewModel: false,
                previewUrl: '',
                contentvotedetail: false,
                editloading: false,

                subloading: false,
                type_options: [],
                category_id: '',

            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getHeight()
            this.gettypes()
            
        },
        methods: {
            // 获取高度
            getHeight() {
                let that = this;
                var title = that.$refs.title.offsetHeight
                that.heights = window.innerHeight - title - 200 + 'px'
                that.mtheights.height = window.innerHeight - 360 + 'px'

                window.onresize = () => {
                    var title = that.$refs.title.offsetHeight
                    that.heights = window.innerHeight - title - 200 + 'px'
                    that.mtheights.height = window.innerHeight - 360 + 'px'

                }
            },
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
            },
            search() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/pc/drugs/Mlist", {
                        page: that.currentPage,
                        page_count: that.pagesize,
                        pid: this.category_id
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.list

                        that.tableData.forEach(ele => {
                            if (ele.detail) {
                                let detailarr = []
                                ele.detail.forEach(e => {
                                    detailarr.push(e.name)
                                })
                                ele.detailarr = detailarr.toString()
                            }
                        })
                        that.count = response.data.data.count
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            gettypes() {
                let that = this
                axios.post("/admin/pc/drugs/Mlist", {
                        page: 1,
                        page_count: 100,
                        pid: 0
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.type_options = response.data.data.list
                        this.category_id=response.data.data.list[0].id
                        that.begin()
                    })
                    .catch(error => {})
            },

            // 新增
            add() {
                let that = this
                that.dialogs = true
                that.eid = '0'
                that.clear()
            },
            submit(formName) {
                let that = this
                if (!that.form.category_id) return this.$message.error('请选择分类')
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        let urls;
                        if (that.eid && that.eid != '0') {
                            urls = "/admin/pc/drugs/update"
                        } else {
                            urls = "/admin/pc/drugs/save"
                        }
                        that.subloading = true
                        axios
                            .post(`${urls}`, {
                                id: that.eid,
                                name: that.form.name,
                                pid: that.form.category_id,
                                sort: '',
                            }, {
                                token: true
                            })
                            .then(response => {
                                if (response.data.code == '200') {
                                    that.dialogs = false
                                    that.search()
                                    that.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                } else {
                                    that.$message.error(response.data.msg);
                                }
                                that.subloading = false
                            })
                            .catch(error => {
                                that.subloading = false

                            })
                    } else {
                        that.$alert('信息遗漏未填')
                        return false;
                    }
                });
            },
          
            handleEdit(index, row) {
                let that = this
                that.dialogs = true
                that.eid = row.id
                that.clear()
                this.editloading = true
                axios
                    .post("/admin/pc/drugs/read", {
                        id: that.eid
                    }, {
                        token: true
                    })
                    .then(response => {
                        var data = response.data.data
                        this.editloading = false
                        if (data) {
                            that.form.name = data.name
                            that.form.category_id = data.pid
                        } else {
                            that.eid = ''
                        }
                    })
                    .catch(error => {})
            },
            handlelookqu(index, row) {
                this.contentvotedetail = true
                this.$nextTick(() => {
                    this.$refs.votelist.textId = row.id
                    this.$refs.votelist.getlist(row.id)
                    // this.$refs.votelist.votelist=row.content
                })
            },
            handleDelete(index, row) {
                let that = this
                that.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/pc/drugs/del", {
                            id: row.id
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                that.search()
                                that.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                            } else {
                                that.$message.error(response.data.message);
                            }
                        })
                        .catch(error => {})

                }).catch(() => {
                    that.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },

            clear() {
                let that = this
                that.form.name = ''
                that.form.category_id = ''
            },
        },

    };
</script>


<style scoped>
    .mr_ck {
        margin: 10px 0;
    }

    .f_w {
        font-weight: 600;
    }

    .bds {
        border-bottom: 1px solid #f5f5f5
    }

    .btn {
        margin-left: 20px;
    }
</style>